const translations = {
  // ── Client Portal ──
  'client.portal.yourProject': 'Your Project',
  'client.portal.noProjectLinked': 'No Project Linked',
  'client.portal.noProjectDesc': 'No project has been linked to your account yet. Japan Homes will connect your project here once it\'s set up.',
  'client.portal.latestFromJH': 'Latest from Japan Homes',
  'client.portal.latestFromJHDesc': 'Important project information, approvals, daily logs, payments, files, and notifications will appear in the relevant sections.',
  'client.portal.actionItems': 'Action Items',
  'client.portal.actionItemsDesc': 'Any items that require your input — such as instructions, payment approvals, or decisions — will appear here. Check the relevant sections for updates.',
  'client.portal.instructions': 'Instructions',
  'client.portal.instructionsDesc': 'Decisions & approvals',
  'client.portal.askQuestion': 'Ask a Question',
  'client.portal.askQuestionDesc': 'Japan Homes will reply',
  'client.portal.projectFiles': 'Project Files',
  'client.portal.projectFilesDesc': 'View photos, documents, and shared files.',
  'client.portal.viewFiles': 'View Files',
  'client.portal.buildJourney': 'Your Build Journey',
  'client.portal.noStagesYet': 'Project stages will appear here once they are set up.',
  'client.portal.projectDetails': 'Project Details',
  'client.portal.managedBy': 'Managed by',
  'client.portal.projectCode': 'Project Code',
  'client.portal.estCompletion': 'Est. Completion',
  'client.portal.status': 'Status',
  'client.portal.type': 'Type',
  'client.portal.projectProgress': 'Project Progress',
  'client.portal.checklistFinal': 'Checklist Final',
  'client.portal.scheduleFinal': 'Schedule Final',
  'client.portal.completed': 'Completed',
  'client.portal.inProgress': 'In Progress',
  'client.portal.done': 'Done',
  'client.portal.upcoming': 'Upcoming',
  'client.portal.delayed': 'Delayed',
  'client.portal.notStarted': 'Not started',
  'client.portal.onHold': 'On Hold',
  'client.portal.refreshing': 'Refreshing...',
  'client.portal.complete': '{percent}% Complete',
  'client.portal.stagesCount': '{completed}/{total} stages',
  'client.portal.currently': 'Currently: {stage} · {percent}% done',
  'client.portal.projectCompleted': 'Project completed',
  'client.portal.itemsCompleted': '{done}/{total} items completed',
  'client.portal.datesTBC': 'TBC',

  // ── Portal Tabs ──
  'client.tab.myProject': 'My Project',
  'client.tab.schedule': 'Schedule',
  'client.tab.checklist': 'Checklist',
  'client.tab.files': 'Files',
  'client.tab.notifications': 'Notifications',
  'client.tab.projectProgramme': 'Project Programme',
  'client.tab.programmeDesc': 'This is the planned schedule for your project. Contact Japan Homes if you have any questions.',
  'client.tab.projectChecklist': 'Project Checklist',
  'client.tab.checklistDesc': 'Review and confirm completed items for your project.',
  'client.tab.dailyLog': 'Daily Log',
  'client.tab.dailyLogDesc': 'Site photos and daily progress updates shared by Japan Homes.',
  'client.tab.changeOrders': 'Change Orders',

  // ── Client Change Orders ──
  'client.changeOrders.empty': 'No Change Orders yet.',
  'client.changeOrders.emptyDesc': 'Japan Homes will share change orders here when scope, specification, or pricing changes apply to your project.',
  'client.changeOrders.pageDesc': 'View change orders, pricing updates, and approvals for your project.',
  'client.changeOrders.tabDesc': 'Change orders and pricing updates shared with you by Japan Homes.',
  'client.changeOrders.attachments': 'Attachments',
  'client.changeOrders.approvalPending': 'Awaiting your approval',
  'client.changeOrders.approvalApproved': 'Approved',
  'client.changeOrders.approvalDeclined': 'Declined',
  'client.changeOrders.approvalNotRequired': 'For your information',
  'client.changeOrders.loadError': 'Failed to load change orders',

  // ── Client Daily Log ──
  'client.dailyLog.title': 'Daily Log',
  'client.dailyLog.siteUpdates': 'Daily Site Updates',
  'client.dailyLog.siteUpdatesDesc': 'Site progress photos shared by Japan Homes',
  'client.dailyLog.dailySiteUpdates': 'Daily Site Updates',
  'client.dailyLog.dailySiteUpdatesDesc': 'These photos have been selected and shared by Japan Homes to keep you informed of your project\'s progress.',
  'client.dailyLog.noSiteUpdates': 'No site updates yet',
  'client.dailyLog.noSiteUpdatesDesc': 'Japan Homes will share site photos and daily progress updates here as work progresses.',
  'client.dailyLog.noPhotos': 'No photos yet. They\'ll appear here once site work begins.',
  'client.dailyLog.photoUnavailable': 'Photo unavailable',

  // ── Client Instructions ──
  'client.instructions.title': 'Instructions',
  'client.instructions.instructionsDecisions': 'Instructions & Decisions',
  'client.instructions.instructionsDesc': 'Order changes, variations, and decisions that require your approval',
  'client.instructions.pending': '{count} pending',
  'client.instructions.noInstructions': 'No instructions yet',
  'client.instructions.noInstructionsDesc': 'Japan Homes will share order changes, variations, and important decisions here.',
  'client.instructions.reason': 'Reason:',
  'client.instructions.cost': 'Cost:',
  'client.instructions.schedule': 'Schedule:',
  'client.instructions.yourResponse': 'Your Response',
  'client.instructions.approve': 'Approve',
  'client.instructions.decline': 'Decline',
  'client.instructions.confirmApproval': 'Confirm Approval',
  'client.instructions.confirmDecline': 'Confirm Decline',
  'client.instructions.approveChangeOrder': 'Approve this change order?',
  'client.instructions.declineChangeOrder': 'Decline this change order?',
  'client.instructions.optionalComment': 'Optional comment...',
  'client.instructions.cancel': 'Cancel',
  'client.instructions.price': 'Price:',
  'client.instructions.currentFinish': 'Current:',
  'client.instructions.newFinish': 'New:',

  // ── Client Payments ──
  'client.payments.title': 'Payments',
  'client.payments.paymentSchedule': 'Payment Schedule',
  'client.payments.noPayments': 'No payment schedule yet',
  'client.payments.noPaymentsDesc': 'Japan Homes will set up your payment schedule soon.',
  'client.payments.totalScheduled': 'Total Scheduled',
  'client.payments.paid': 'Paid',
  'client.payments.remaining': 'Remaining',
  'client.payments.overdue': 'Overdue',
  'client.payments.dueNow': 'Due Now',
  'client.payments.pending': 'Pending',
  'client.payments.onTrack': 'On track',
  'client.payments.amount': 'Amount',
  'client.payments.dueDate': 'Due date',
  'client.payments.confirmPayment': 'Confirm Payment',
  'client.payments.confirming': 'Confirming…',
  'client.payments.youConfirmed': 'You confirmed this payment',
  'client.payments.confirmedByJH': 'Confirmed by Japan Homes',
  'client.payments.failedToLoad': 'Failed to load payment schedule',
  'client.payments.gstNote': 'All amounts are in {currency} and include GST where applicable. Contact Japan Homes if you have any questions about your payment schedule.',
  'client.payments.attention': 'Attention',
  'client.payments.paymentOverdue': '{count} payment{s} overdue',
  'client.payments.paymentDue': '{count} payment{s} due now',
  'client.payments.makePayment': 'Please make the payment and tap Confirm Payment to notify Japan Homes.',

  // ── Client Questions ──
  'client.questions.title': 'Questions',
  'client.questions.yourQuestions': 'Your Questions',
  'client.questions.askDesc': 'Ask Japan Homes anything about your project',
  'client.questions.ask': 'Ask',
  'client.questions.client': 'Client',
  'client.questions.management': 'Management',
  'client.questions.questionTitle': 'Question Title',
  'client.questions.questionPlaceholder': 'e.g. Kitchen tile colour',
  'client.questions.details': 'Details',
  'client.questions.detailsPlaceholder': 'Describe your question in more detail...',
  'client.questions.attachments': 'Attachments',
  'client.questions.addFiles': 'Add files (JPG, PNG, PDF)',
  'client.questions.filesUploaded': 'Files are uploaded before you submit',
  'client.questions.noQuestions': 'No questions yet',
  'client.questions.noQuestionsDesc': 'Ask Japan Homes anything about your project and they\'ll reply here.',
  'client.questions.clientQuestion': 'Client Question',
  'client.questions.answered': 'Answered',
  'client.questions.open': 'Open',
  'client.questions.awaitingResponse': 'Awaiting response from Japan Homes',
  'client.questions.japanHomesReply': 'Japan Homes Reply',
  'client.questions.send': 'Send',

  // ── Client Updates ──
  'client.updates.title': 'Updates',
  'client.updates.latestSitePhotos': 'Latest Site Photos',
  'client.updates.projectUpdates': 'Project Updates',
  'client.updates.noUpdates': 'No updates yet',
  'client.updates.noUpdatesDesc': 'Japan Homes will post updates here as your project progresses.',
  'client.updates.noPhotosYet': 'No photos yet. They\'ll appear here once site work begins.',
  'client.updates.commentOnUpdate': 'Comment on this update',
  'client.updates.hideComments': 'Hide comments',
  'client.updates.loadingComments': 'Loading comments...',
  'client.updates.comments': '{count} comment{s}',
  'client.updates.reply': 'Reply',
  'client.updates.cancelReply': 'Cancel reply',
  'client.updates.writeReply': 'Write a reply...',
  'client.updates.leaveComment': 'Leave a comment or question for Japan Homes...',
  'client.updates.comment': 'Comment',
  'client.updates.japanHomes': 'Japan Homes',

  // ── Client Notifications ──
  'client.notifications.title': 'Notifications',
  'client.notifications.all': 'All',
  'client.notifications.unread': 'Unread',
  'client.notifications.markAllRead': 'Mark all read',
  'client.notifications.noNotifications': 'No notifications',
  'client.notifications.noNotificationsDesc': 'Notifications will appear here when Japan Homes posts updates',
  'client.notifications.allCaughtUp': 'All caught up!',
  'client.notifications.noUnread': 'No unread notifications',

  // ── Embed: Daily Log ──
  'embed.dailyLog.infoBanner': 'Daily Site Updates',
  'embed.dailyLog.infoBannerDesc': 'These photos have been selected and shared by Japan Homes to keep you informed of your project\'s progress.',
  'embed.dailyLog.noSiteUpdates': 'No site updates yet',
  'embed.dailyLog.noSiteUpdatesDesc': 'Japan Homes will share site photos and daily progress updates here as work progresses.',

  // ── Embed: Instructions ──
  'embed.instructions.noInstructions': 'No instructions yet',
  'embed.instructions.noInstructionsDesc': 'Japan Homes will share order changes, variations, and important decisions here.',
  'embed.instructions.pendingDecisions': '{count} decision{s} pending',
  'embed.instructions.pendingDecisionsDesc': 'Please review and approve or decline the items below.',

  // ── Embed: Notifications ──
  'embed.notifications.viewAll': 'View All Notifications',

  // ── Embed: Updates ──
  'embed.updates.noUpdates': 'No updates yet',
  'embed.updates.noUpdatesDesc': 'Japan Homes will post updates here as your project progresses.',
  'embed.updates.noPhotos': 'No photos yet. They\'ll appear here once site work begins.',

  // ── Common Status Labels ──
  'status.open': 'Open',
  'status.inReview': 'In Review',
  'status.resolved': 'Resolved',
  'status.pending': 'Pending',
  'status.approved': 'Approved',
  'status.declined': 'Declined',
  'status.acknowledged': 'Acknowledged',
  'status.completed': 'Completed',
  'status.sent': 'Sent',
  'status.awaitingApproval': 'Awaiting Approval',
  'status.closed': 'Closed',
  'status.due': 'Due Now',
  'status.overdue': 'Overdue',
  'status.upcoming': 'Upcoming',
  'status.paid': 'Paid',
  'status.confirmed': 'Confirmed',
  'status.awaitingReview': 'Awaiting Review',

  // ── Common Type Labels ──
  'type.orderChange': 'Order Change',
  'type.variation': 'Variation',
  'type.approvalRequest': 'Approval Required',
  'type.instruction': 'Instruction',
  'type.designDecision': 'Design Decision',
  'type.payment': 'Payment',
  'type.scheduleChange': 'Schedule Change',
  'type.changeOrder': 'Change Order',
  'type.progressUpdate': 'Progress Update',
  'type.question': 'Question',
  'type.issueReport': 'Issue Report',
  'type.completion': 'Completed',

  // ── Common Actions ──
  'common.readMore': 'Read more',
  'common.showLess': 'Show less',
  'common.noReplies': 'No replies yet',
  'common.loading': 'Loading...',
  'common.today': 'Today',
  'common.justNow': 'Just now',
  'common.minAgo': '{count} min ago',
  'common.hrAgo': '{count} hr{s} ago',
  'common.dayAgo': '{count} day{s} ago',
  'common.dueToday': 'Due today',
  'common.dueTomorrow': 'Due tomorrow',
  'common.overdue': 'Overdue',

  // ── Instruction type labels ──
  'client.type.orderChange': 'Order Change',
  'client.type.variation': 'Variation',
  'client.type.approvalRequired': 'Approval Required',
  'client.type.instruction': 'Instruction',
  'client.type.designDecision': 'Design Decision',
  'client.type.payment': 'Payment',
  'client.type.scheduleChange': 'Schedule Change',
  'client.type.changeOrder': 'Change Order',

  // ── Instruction status labels ──
  'client.status.pending': 'Pending',
  'client.status.sent': 'Sent',
  'client.status.inProgress': 'In Progress',
  'client.status.approved': 'Approved',
  'client.status.declined': 'Declined',
  'client.status.clientApproved': 'Client Approved',
  'client.status.clientDeclined': 'Client Declined',
  'client.status.acknowledged': 'Acknowledged',
  'client.status.closed': 'Closed',
  'client.status.completed': 'Completed',
  'client.status.awaitingApproval': 'Awaiting Approval',
  'client.status.confirming': 'Awaiting Review',

  // ── Payment status labels ──
  'client.payment.paid': 'Paid',
  'client.payment.confirmed': 'Confirmed',
  'client.payment.awaitingReview': 'Awaiting Review',
  'client.payment.dueNow': 'Due Now',
  'client.payment.overdue': 'Overdue',
  'client.payment.upcoming': 'Upcoming',
};

export default translations;